
<grupper-list-invitasjoner/>
<grupper-list-ordinaere [ordinaere]="ordinaere()"/>
<grupper-list-maler [maler]="maler()"/>
